import React from 'react';
import { useSelector } from 'react-redux';
import { convertDateDDMMYYYY } from 'utils/dateConvertor';
import { formatAmount } from 'utils/formatPrice';
import 'bootstrap/dist/css/bootstrap.min.css';

const CardComponent = () => {
  const countWater = useSelector((state) => state?.dashboardReducer?.chartData?.countwater) || [];
  const countOil = useSelector((state) => state?.dashboardReducer?.chartData?.countoil) || [];
  const secondCardData = useSelector((state) => state?.dashboardReducer?.chartData?.data) || [];
  const waterCost = formatAmount((countWater.reduce((sum, item) => sum + (item.total_cost || 0), 0)).toFixed(2));
  const oilCost = formatAmount((countOil.reduce((sum, item) => sum + (item.totolCost || 0), 0)).toFixed(2));
  const totalWaterAdded = (countWater.reduce((sum, item) => sum + (item.total_water_added || 0), 0)).toFixed(2);
  const totalOilAdded = (countOil.reduce((sum, item) => sum + (item.totalOil || 0), 0)).toFixed(2);
  const totalWaterPh = secondCardData.length > 0 ? (secondCardData.reduce((sum, item) => sum + (item.water_ph || 0), 0) / secondCardData.length).toFixed(1) : '0.0';
  const totalWaterHardness = secondCardData.length > 0 ? (secondCardData.reduce((sum, item) => sum + (item.water_hardness || 0), 0) / secondCardData.length).toFixed(1) : '0.0';

  return (
    <div className="row ">

      {/* first card */}
      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4 mt-md-2" style={{}}>
        <div className="card dashboard_card dashboard_first_card">
          <div className="card-body">
            <h5 className="card-title first_card_title_color text-center">Cost</h5>
            <div className="sub-card-container d-flex justify-content-between">
              <div className="card sub-card first_sub_card">
                <div className="card-body d-block">
                  <p className="card_first_text">Water</p>
                  <p className="card_second_text">₹ {waterCost?.value}</p>
                </div>
              </div>
              <div className="card sub-card first_sub_card" >
                <div className="card-body d-block">
                  <p className="card_first_text">Oil</p>
                  <p className="card_second_text">₹ {oilCost?.value}{oilCost?.label}</p>
                  <span className="card_third_text">&nbsp;</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4 mt-md-2" >
        <div className="card dashboard_card dashboard_second_card">
          <div className="card-body">
            <h5 className="card-title first_card_title_color text-center">Consumption</h5>
            <div className="sub-card-container d-flex justify-content-between">
              <div className="card sub-card second_sub_card">
                <div className="card-body d-block">
                  <p className="card_first_text">Water</p>
                  <p className="card_second_text">{totalWaterAdded} L</p>
                </div>
              </div>
              <div className="card sub-card second_sub_card" >
                <div className="card-body d-block">
                  <p className="card_first_text">Oil</p>
                  <p className="card_second_text">{totalOilAdded} L</p>
                  <span className="card_third_text">&nbsp;</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4 mt-md-2" >
        <div className="card dashboard_card dashboard_third_card">
          <div className="card-body">
            <h5 className="card-title first_card_title_color text-center">Water Quality</h5>
            <div className="sub-card-container d-flex justify-content-between">
              <div className="card sub-card third_sub_card">
                <div className="card-body d-block">
                  <p className="card_first_text">pH</p>
                  <p className="card_second_text">
                    {totalWaterPh}
                  </p>
                  <span className="card_third_text">{convertDateDDMMYYYY(secondCardData[0]?.latest_water_ph_date) || '-'}</span>
                </div>
              </div>
              <div className="card sub-card third_sub_card d-block">
                <div className="card-body d-block">
                  <p className="card_first_text">Hardness</p>
                  <p className="card_second_text">
                    {totalWaterHardness}
                  </p>
                  <span className="card_third_text">{convertDateDDMMYYYY(secondCardData[0]?.latest_water_hardness_date) || '-'}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


    </div>

  );
};

export default CardComponent;


